import type { ButtonColor, ButtonVariant } from '@ksyos/design-system';
import { Button, ButtonRow } from '@ksyos/design-system';
import { FundingType } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';

type FinancingFlexProcessesFooterButtonsProps = {
    isReprocessButtonDisabled: boolean;
    onReprocess: (fundingType: FundingType) => void;
};

export function FinancingFlexProcessesFooterButtons({
    isReprocessButtonDisabled,
    onReprocess,
}: FinancingFlexProcessesFooterButtonsProps) {
    const language = getSelectedLanguage();

    const buttons = [
        {
            color: 'secondary',
            isDisabled: isReprocessButtonDisabled,
            label: language.finance.fundingAccordingToSettings,
            onClick: () => onReprocess(FundingType.fundingAccordingToSettings),
            variant: 'outline',
        },
    ];

    return (
        <ButtonRow>
            {buttons.map(({ color, isDisabled, onClick, variant, label }) => (
                <Button
                    color={(color ?? 'secondary') as ButtonColor}
                    isDisabled={isDisabled}
                    key={`${label}-${variant}-${color}`}
                    onClick={onClick}
                    variant={variant as ButtonVariant}
                >
                    {label}
                </Button>
            ))}
        </ButtonRow>
    );
}
